import React, { useContext, Suspense } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import app from "./Views/app";
import User from "./Views/user";
import error from "./Views/error";
import main from "./Views";
import { SnackbarProvider } from "notistack";
import { ThemeContext } from "./Context/theme-context";
import { ThemeProvider, makeStyles } from "@material-ui/styles";
import Homepage from "./Views/home";
import Privacy from "./Views/privacynterm/privacy";
import Term from "./Views/privacynterm/term";
import Meaauth from "./Views/meaauth";
import Embed from "./Views/embed";
import Activate from "./Views/activate";
import ResetPassword from "./Views/resetPassword";
import Loading from "./Component/Item/Loading";

const useStyle = makeStyles({
  "@global": {
    body: {
      margin: 0,
      padding: 0,
      // fontFamily: "Noto Sans,Noto Sans Thai"
      fontFamily: "Kanit",
    },
  },

  dark: {
    height: "100vh",
    width: "100vw",

    overflowY: "hidden",
    overflowX: "hidden",
    background: "#354551",
  },
  light: {
    height: "100%",
    // width: "100vw",
    // overflowY: "hidden",
    // overflowX: "hidden",
    background: "#eee",
  },
});

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        localStorage.getItem("token") ? (
          <Suspense fallback={<Loading />}>
            <Component {...props} />
          </Suspense>
        ) : (
          <Redirect to={{ pathname: "/user/login" }} />
        )
      }
    />
  );
};

const App = () => {
  const classes = useStyle();
  const { theme } = useContext(ThemeContext);

  const testiframe = () => {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "black",
        }}
      >
        <iframe
          title="MEA"
          width="50%"
          height="50%"
          frameborder="0"
          allow="geolocation"
          src={`http://localhost:3000/embed/apikey=7zJqsrDpvTIsxY21ZPHAGikYQKaDMbPDOkLUMA5CmRK5hOfZKyHwcxtdiaBCVrUA?q=100.554894,13.721237&z=15&type=public`}
        ></iframe>
      </div>
    );
  };

  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider maxSnack={3}>
        <div
          className={
            theme.palette.type === "light" ? classes.light : classes.dark
          }
        >
          <Router>
            <Switch>
              <PrivateRoute path="/app" component={app} />
              <Route path="/mea-auth" component={Meaauth} />
              <Route path="/activate" component={Activate} />
              <Route path="/user" component={User} />
              <Route path="/home" component={Homepage} />
              <Route path="/error" exact component={error} />
              <Route path="/privacy" component={Privacy} />
              <Route path="/reset-password" component={ResetPassword} />
              <Route path="/terms" component={Term} />
              <Route path="/embed/apikey=:apikey" component={Embed} />
              <Route path="/testiframe" component={testiframe} />
              <Route path="/" exact component={main} />
              <Redirect to="/error" />
            </Switch>
          </Router>
        </div>
      </SnackbarProvider>
    </ThemeProvider>
  );
};

export default App;
